<template>
  <div>
    <div class="_footer" v-if="$store.state.screenWidth > 960">
      <div class="_center">
        <div class="_top">
          <div class="_left">
            <ul class="_left_list">
              <li class="_item _title" @click="toNo1">
                <a href="javascript:;">关于模数</a>
              </li>
              <li class="_item">
                <a href="#/about">关于模数</a>
              </li>

            </ul>
            <ul class="_left_list">
              <li class="_item _title">
                <a href="#/product/lvp">产品中心</a>
              </li>
              <li class="_item">
                <a href="#/product/lvp">智慧后勤</a>
              </li>
              <li class="_item">
                <a href="#/product/opm">智慧节能</a>
              </li>
              <!-- <li class="_item">
              <a href="#/news/report">专题报道</a>
            </li> -->
            </ul>
            <ul class="_left_list">
              <li class="_item _title">
                <a href="#/project">解决方案</a>
              </li>
              <li class="_item">
                <a href="#/projectShow/pro1">智慧城市</a>
              </li>              
                         <li class="_item">
                <a href="#/projectShow/pro2">智慧楼宇</a>
              </li>     <li class="_item">
                <a href="#/projectShow/pro3">智慧医院</a>
              </li>  
                             
                            <li class="_item">
                <a href="#/projectShow/pro4">智慧能源</a>
              </li>  
              <li class="_item">
                <a href="#/projectShow/pro5">智慧交通</a>
              </li>

            </ul>
            <ul class="_left_list">
              <li class="_item _title">
                <a href="/news_center.html">新闻动态</a>
              </li>
              <li class="_item">
                <a href="/news_center.html">企业资讯</a>
              </li>
            </ul>
            <ul class="_left_list">
              <li class="_item _title">
                <a href="#/contact">联系我们</a>
              </li>
              <li class="_item">
                <a href="#/contact">战略合作</a>
              </li>
              <li class="_item">
                <a href="#/contact/relation">联系我们</a>
              </li>
              <!-- <li class="_item">
                <a href="#/contact/join_us">诚聘英才</a>
              </li>  -->
            </ul>
          </div>
          <div class="_right" >
            <div class="_info">
              <p>
                <i class="iconfont icon-daohangdizhi" style="margin-right: 10px"></i>
                浙江省湖州市东坡路1558号34号楼35号楼
              </p>
              <p><i class="iconfont icon-24gf-telephone" style="margin-right: 10px"></i>汪女士:15968177119</p>
              <p><i class="iconfont icon-24gf-telephone" style="margin-right: 10px"></i>林先生:13511269473</p>
              <!-- <p><i class="iconfont icon-24gf-telephone" style="margin-right: 10px"></i>400-0098-709</p>
              <p><i class="iconfont icon-youxiang" style="margin-right: 10px"></i>bimeng0913@163.com</p> -->
            </div>
            <div class="_wechat">
              <div class="_img"></div>
              <p>微信公众号</p>
            </div>
            <div class="_wechat">
              <div class="_img_video"></div>
              <p>微信视频号</p>
            </div>
          </div>
        </div>
        <div class="_line"></div>
        <div class="_btm">
          <span style="margin-right: 40px">
            Copyright &copy; MOS IOT Technology Zhejiang CO.,LTD 
          </span>
          <img src="/static/img/icon_zgw.png" alt="" />
          <span>浙公网安备33059102000380号&nbsp;</span>
          <span class="gjHover" @click="toGJ">浙ICP备2024058818号-1</span>
        </div>
      </div>
    </div>
    <MobileFooter v-else-if="$store.state.screenWidth <= 960" />
  </div>
</template>

<script>
import MobileFooter from "../mobile/MobileFooter.vue";
export default {
  components: {
    MobileFooter,
  },
  methods: {
    toNo1() {
      if (this.$route.name === 'About') {
        this.$parent.$refs.bannerNav && this.$parent.$refs.bannerNav.toNo1()
        return
      }
      this.$router.push({
        name: 'About',
        params: {
          name: '1'
        }
      })
    },
    toNo2() {
      if (this.$route.name === 'About') {
        this.$parent.$refs.bannerNav && this.$parent.$refs.bannerNav.toNo2()
        return
      }
      this.$router.push({
        name: 'About',
        params: {
          name: '2'
        }
      })
    },
    toNo3() {
      if (this.$route.name === 'About') {
        this.$parent.$refs.bannerNav && this.$parent.$refs.bannerNav.toNo3()
        return
      }
      this.$router.push({
        name: 'About',
        params: {
          name: '3'
        }
      })
    },
    toNo4() {
      if (this.$route.name === 'About') {
        this.$parent.$refs.bannerNav && this.$parent.$refs.bannerNav.toNo4()
        return
      }
      this.$router.push({
        name: 'About',
        params: {
          name: '4'
        }
      })
    },
    toNo5() {
      if (this.$route.name === 'About') {
        this.$parent.$refs.bannerNav && this.$parent.$refs.bannerNav.toNo5()
        return
      }
      this.$router.push({
        name: 'About',
        params: {
          name: '5'
        }
      })
    },
    toGJ() {
      window.open('https://beian.miit.gov.cn/')
    }
  }
}
</script>

<style lang="scss" scoped>
._footer {
  height: 3.8rem;
  // 使用本地图片资源
  background: url('../../assets/images/shouyefoot.jpg') no-repeat center;
  background-size: cover;

  ._center {
    height: 100%;
    width: 14.03rem;
    margin: 0 auto;

    ._top {
      padding-top: 0.5rem;
      display: flex;
      justify-content: space-between;

      ._left {
        width: 50%;
        display: flex;

        ._left_list {
          margin-right: 0.58rem;

          ._item {
            margin-bottom: 0.18rem;
            height: 0.2rem;
            line-height: 0.2rem;
          }

          ._title {
            margin-bottom: 0.2rem;
          }

          ._item a {
            font-size: 0.16rem;
            color: #c2c2c2;
            vertical-align: bottom;
            text-decoration: none;
            transition: color 0.3s;

            &:hover {
              color: #3660aa;
            }
          }

          ._title a {
            font-size: 0.18rem;
            color: #fff;
          }
        }
      }

      ._right {
        width: 50%;
        display: flex;
        justify-content: space-between;

        ._info {
          flex: 1;
          min-width: 3.8rem;
          white-space: nowrap;

          p {
            font-size: 0.16rem;
            color: #fff;
            margin-bottom: 0.35rem;
          }
        }

        ._wechat {
          color: #fff;
          text-align: center;
          flex-shrink: 0;

          & + ._wechat {
            margin-left: 0.4rem;
          }

          ._img {
            width: 1.3rem;
            height: 1.3rem;
            background: url('../../assets/images/wechat.jpg') no-repeat;
            background-size: cover;
            background-position: center;
            margin-bottom: 0.16rem;
          }

          ._img_video {
            width: 1.3rem;
            height: 1.3rem;
            background:  url('../../assets/images/video.jpg') no-repeat;
            background-size: cover;
            background-position: center;
            margin-bottom: 0.16rem;
          }

          p {
            font-size: 0.16rem;
          }
        }
      }
    }

    ._line {
      width: 100%;
      height: 0.01rem;
      background: #4d4d4d;
      margin-top: 0.05rem;
    }

    ._btm {
      margin-top: 0.3rem;
      font-size: 0.16rem;
      color: #fff;
      text-align: center;

      img {
        width: 0.2rem;
        height: 0.2rem;
        vertical-align: text-top;
        margin-right: 0.04rem;
      }

      span {
        margin: 0 0.06rem;
      }

      .gjHover {
        cursor: pointer;
        &:hover {
          color: #ccc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue